"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapIncentivesForOffer = exports.getCashIncentives = exports.getLeaseIncentives = exports.getFinanceIncentives = exports.flattenAllIncentives = exports.combineIncentivesByConditionType = exports.createIncentiveIncentiveIdentifier = exports.getIncentiveIds = exports.mapAllIncentivesId = exports.mapIncentivesByOfferType = exports.formatIncentives = exports.mapIncentiveIdsToPDIds = void 0;
var defaultIncentives = {
    nonConditionals: [],
    conditionals: []
};
var mapIncentiveIdsToPDIds = function (incentives) {
    var mappings = {
        incentives: {}
    };
    incentives.map(function (incentive) {
        mappings.incentives[incentive.id] = incentive.pdId;
    });
    return mappings;
};
exports.mapIncentiveIdsToPDIds = mapIncentiveIdsToPDIds;
var formatIncentives = function (incentives, offerType, identifier) {
    var formattedIncentives = incentives.map(function (incentive) {
        var _incentive = incentive;
        if (offerType !== 'cash') {
            _incentive.pdId = incentive.id;
            _incentive.description = incentive.description || 'See the dealer for details';
        }
        _incentive.id = "".concat(identifier, "_").concat(offerType, "_").concat(incentive.id);
        return _incentive;
    });
    return formattedIncentives;
};
exports.formatIncentives = formatIncentives;
var mapIncentivesByOfferType = function (incentives) {
    if (incentives === void 0) { incentives = defaultIncentives; }
    var conditionals = incentives.conditionals, nonConditionals = incentives.nonConditionals;
    var offerIncentives = {
        conditionals: (0, exports.mapAllIncentivesId)(conditionals) || [],
        nonConditionals: (0, exports.mapAllIncentivesId)(nonConditionals) || []
    };
    return offerIncentives;
};
exports.mapIncentivesByOfferType = mapIncentivesByOfferType;
var mapAllIncentivesId = function (incentives) {
    var allIds = incentives.map(function (incentive) { return incentive.id; });
    return allIds;
};
exports.mapAllIncentivesId = mapAllIncentivesId;
var getIncentiveIds = function (incentives) {
    var mappedIncentives = {};
    incentives.map(function (incentive) {
        mappedIncentives[incentive.id] = incentive;
    });
    return mappedIncentives;
};
exports.getIncentiveIds = getIncentiveIds;
var createIncentiveIncentiveIdentifier = function (conditionType) {
    var identifier;
    if (typeof conditionType === 'string') {
        identifier = conditionType.toLowerCase().replace('s', '');
    }
    return identifier;
};
exports.createIncentiveIncentiveIdentifier = createIncentiveIncentiveIdentifier;
var combineIncentivesByConditionType = function (offerIncentives, offerType) {
    if (offerIncentives === void 0) { offerIncentives = []; }
    var incentives = [];
    Object.keys(offerIncentives).map(function (conditionType) {
        var identifier = (0, exports.createIncentiveIncentiveIdentifier)(conditionType);
        if (conditionType && identifier) {
            var incentivesByConditions = offerIncentives[conditionType];
            var formattedIncentives = (0, exports.formatIncentives)(incentivesByConditions, offerType, identifier);
            incentives.push.apply(incentives, formattedIncentives);
        }
    });
    return incentives;
};
exports.combineIncentivesByConditionType = combineIncentivesByConditionType;
var flattenAllIncentives = function (leaseIncentives, financeIncentives, cashIncentives) {
    var lease = (0, exports.combineIncentivesByConditionType)(leaseIncentives, 'lease');
    var finance = (0, exports.combineIncentivesByConditionType)(financeIncentives, 'finance');
    var cash = (0, exports.combineIncentivesByConditionType)(cashIncentives, 'cash');
    return __spreadArray(__spreadArray(__spreadArray([], lease, true), finance, true), cash, true);
};
exports.flattenAllIncentives = flattenAllIncentives;
var getFinanceIncentives = function (offer) {
    var finance = (offer && offer.finance) || {};
    var incentives = (finance && finance.incentives) || defaultIncentives;
    return incentives;
};
exports.getFinanceIncentives = getFinanceIncentives;
var getLeaseIncentives = function (offer) {
    var lease = (offer && offer.lease) || {};
    var incentives = (lease && lease.incentives) || defaultIncentives;
    return incentives;
};
exports.getLeaseIncentives = getLeaseIncentives;
var getCashIncentives = function (offer) {
    var cash = (offer && offer.cash) || {};
    var incentives = (cash && cash.incentives) || defaultIncentives;
    return incentives;
};
exports.getCashIncentives = getCashIncentives;
var mapIncentivesForOffer = function (offer) {
    var financeIncentives = (0, exports.getFinanceIncentives)(offer);
    var cashIncentives = (0, exports.getCashIncentives)(offer);
    var leaseIncentives = (0, exports.getLeaseIncentives)(offer);
    var incentives = {
        allIds: [],
        byId: {},
        byOfferType: {
            finance: (0, exports.mapIncentivesByOfferType)(financeIncentives),
            lease: (0, exports.mapIncentivesByOfferType)(leaseIncentives),
            cash: (0, exports.mapIncentivesByOfferType)(cashIncentives)
        }
    };
    var allIncentives = (0, exports.flattenAllIncentives)(leaseIncentives, financeIncentives, cashIncentives);
    incentives.allIds = (0, exports.mapAllIncentivesId)(allIncentives);
    incentives.byId = (0, exports.getIncentiveIds)(allIncentives);
    var mappings = (0, exports.mapIncentiveIdsToPDIds)(allIncentives);
    return __assign(__assign({}, incentives), { mappings: mappings.incentives });
};
exports.mapIncentivesForOffer = mapIncentivesForOffer;
